import { withStaticSelect } from 'shared/components/data-display/withSelectors';
import withQosSearchableSelect from 'shared/components/internet/QosSearchableSelect';
import { AUTH_METHODS, INTERNET_TYPES } from 'shared/constants/building';

// Field-display config for a building's internet settings
const internetDescriptions = [
  {
    key: 'service_type',
    label: 'Service Type',
    editor: withStaticSelect({
      valueAsLabel: true,
      options: Object.values(INTERNET_TYPES),
      disableClearable: true,
    }),
  },
  {
    key: 'auth_method',
    label: 'Auth Method',
    editor: withStaticSelect({
      valueAsLabel: true,
      options: Object.values(AUTH_METHODS),
      disableClearable: true,
    }),
  },
  {
    key: 'qos_management',
    label: 'Management',
    editor: withStaticSelect({
      valueAsLabel: true,
      options: ['USER', 'GROUP'],
      disableClearable: true,
    }),
  },
  {
    key: 'qos',
    id: (b) => b.id,
    formatter: (b) => b.qos.description,
    label: 'Default Speed',
    editor: withQosSearchableSelect(),
    editKey: 'qos_id',
  },
];

export default internetDescriptions;
